import React from 'react';
import { CajaHabilitar, ImagenEmpleado } from '../../configuracion/apiUrls';
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext';
import ModalPerfil from '../../paginas/empleados/ModalPerfil';
import { AxiosPrivado } from '../axios/Axios';
import { mostraAlertaOk, mostraAlertaPersonalizada } from '../alerts/sweetAlert';
import { ErroresPeticion } from '../axios/ErroresPeticion';

const PerfilUsuario = ({ datos }) => {
    const { usuario, estacion } = useContextUsuario();

    const imagen = usuario?.datoPersonales.imagen ? ImagenEmpleado + usuario?.datoPersonales.imagen : ImagenEmpleado + "empleados.jpeg";

    const habilitarCaja = () => {
        mostraAlertaPersonalizada({
            titulo: "¿Deseas realizar una solicitud para habilitar este dipositivo como caja?",
            mensaje: "Se enviará un correo indicando su solicitud.",
            icono: "question",
            textoConfirmacion: "Sí",
            textoCancelacion: "No",
            accion: async (confirmado) => {
                if (confirmado) {
                    try {
                        const respuesta = (await AxiosPrivado.post(CajaHabilitar, { usuario: usuario, estacionDatos: estacion }));
                        mostraAlertaOk('Correo enviado correctamente','success');
                    } catch (error) {
                        ErroresPeticion(error);
                    }
                    
                }
            },
        });
    }
    return (
        <div className="card card-primary card-outline" style={{ width: '300px', height: 'auto' }}> {/* Definir tamaño del card */}
            <div className="card-body box-profile">
                <div className="text-center">
                    <img
                        className="profile-user-img img-fluid img-circle"
                        src={imagen}
                        alt="Imagen de perfil de usuario"
                        crossOrigin="anonymous"
                        style={{ width: '120px', height: '120px' }} /> {/* Definir tamaño de la imagen */}
                </div>
                <h3 className="profile-username text-center">{usuario?.datoPersonales.nombreCompleto}</h3>
                <p className="text-muted text-center">{usuario?.datoPersonales.Cargo.nombre_cargo}</p>
                <hr />
                <div className="card-body">
                    <strong><i className="fas fa-envelope mr-1" /> Correo</strong>
                    <p className="text-muted">
                        {usuario?.correo}
                    </p>
                    <strong><i className="fas fa-phone mr-1" /> Telefonos</strong>
                    {
                        usuario?.datoPersonales.EmpleadoTelefonos
                            .map((f, i) => (
                                <p key={i} className="text-muted">
                                    {f.telefono}
                                </p>
                            ))
                    }
                    <strong><i className="fas fa-map-marker-alt mr-1" /> Direcciones</strong>
                    {
                        usuario?.datoPersonales.EmpleadoDireccions.map((f, i) => (
                            <p key={i} className="text-muted">
                                {f.direccion}
                            </p>
                        ))
                    }
                    <hr />
                </div>
                <ModalPerfil datos={usuario}></ModalPerfil>
                <button type="button" className="btn btn-outline-warning mx-2" onClick={habilitarCaja} title='Caja'>
                    <i className="fas fa-cash-register mr-1 mx-1" />
                </button>
            </div>
        </div>
    );
}

export default PerfilUsuario;
